import moment from 'moment';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formatDate = (dateString, dateFormat?) => {
  return dateString ? moment(dateString).format(dateFormat || 'DD MMM YYYY') : '';
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const calculateDates = (dateFilter) => {
  if (!dateFilter.relativeRange) {
    return { startDate: formatDate(dateFilter.startDate, 'YYYY-MM-DD'), endDate: formatDate(dateFilter.endDate, 'YYYY-MM-DD') };
  }
  let startDate = moment(new Date());

  // eslint-disable-next-line default-case
  switch (dateFilter.relativeRange) {
    case 'LAST_24HRS':
      startDate = startDate.add(-1, 'days');
      break;
    case 'LAST_7DAYS':
      startDate = startDate.add(-7, 'days');
      break;
    case 'LAST_30DAYS':
      startDate = startDate.add(-30, 'days');
      break;
    case 'LAST_90DAYS':
      startDate = startDate.add(-90, 'days');
      break;
  }

  return { startDate: formatDate(startDate, 'YYYY-MM-DD'), endDate: formatDate(new Date(), 'YYYY-MM-DD') };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const addDateFilter = (filters, label, startDate, endDate) => {
  if (startDate || endDate) {
    const obj: any = {};

    if (startDate) {
      obj.min = startDate;
    }

    if (endDate) {
      obj.max = endDate;
    }

    // eslint-disable-next-line no-param-reassign
    filters[label] = obj;
  }
};
